import React, { Component, PropTypes } from 'react'
import { browserHistory } from 'react-router'

import Header from './header'
import Button from './ui/button'

export default class OnboardingInstructions extends Component {
    static propTypes = {
        docs: PropTypes.object.isRequired,
        docsActions: PropTypes.shape({
            loadDoc: PropTypes.func.isRequired,
        }).isRequired,
    }

    componentWillMount() {
        this.props.docsActions.loadDoc('onboarding-instructions')
    }

    render() {
        if (! ('onboarding-instructions' in this.props.docs)) {
            return null
        }

        return (
            <div>
                <Header title="Onboarding Instructions" />

                <div className="content">
                    <div className="content__inner">
                        <div
                            dangerouslySetInnerHTML={{ __html: this.props.docs['onboarding-instructions'].body }}
                        />

                        <hr />

                        <Button onClick={ () => { browserHistory.push('/ica') } } status="primary">
                            Continue onboarding
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/onboarding_instructions.js